export default __webpack_public_path__ + "static/media/joann-wedding-announcement.b47e6637.jpg";